var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{staticClass:"breadcrumbs",attrs:{"separator":"/"}},_vm._l((_vm.breadcrumbs),function(breadcrumb,index){return _c('el-breadcrumb-item',{key:index,attrs:{"to":breadcrumb.route || null},on:{"click":function($event){return _vm.toPage(breadcrumb)}}},[_vm._v(_vm._s(breadcrumb.title || breadcrumb))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }